<!-- src/components/AdminPage.vue -->
<template>
  <v-card style="width: 100%">
    <v-tabs v-model="tab" bg-color="#767676">
      <v-tab value="one">Usage Stats</v-tab>
      <v-tab value="two">Add Gallery Item</v-tab>

      <!-- show the ip -->
      <v-tab v-if="myIp" class="text-right" disabled="true">
        <span>My IP: {{ myIp }}</span>
      </v-tab>
      <v-spacer></v-spacer>
      <v-btn
        :loading="isUpdating"
        :disabled="isUpdating"
        @click="updateVideos"
        color="blue"
      >
        <template v-if="!isUpdating && !updateSuccess">Update Videos</template>
        <template v-if="updateSuccess">Done</template>
      </v-btn>

      <v-btn @click="logout()" color="red">Logout</v-btn>
    </v-tabs>

    <v-card-text>
      <v-tabs-window v-model="tab">
        <v-tabs-window-item value="one">
          <UsageStats />
        </v-tabs-window-item>

        <v-tabs-window-item value="two">
          <AddGalleryItem />
        </v-tabs-window-item>
      </v-tabs-window>
    </v-card-text>
  </v-card>
</template>

<script>
import AddGalleryItem from "@/views/AddGalleryItem.vue";
import UsageStats from "@/components/UsageStats.vue";
import { AdminWS } from "@/services/AdminWS";
import { useAuthStore } from "@/stores/authStore";

export default {
  name: "AdminPage",
  components: {
    AddGalleryItem,
    UsageStats,
  },
  data() {
    return {
      tab: null,
      AuthStore: useAuthStore(),
      isUpdating: false,
      updateSuccess: false,
      myIp: null,
    };
  },
  mounted() {
    this.getMyIp();
  },
  methods: {
    logout() {
      this.AuthStore.logout();
      window.location.reload();
    },

    getMyIp() {
      AdminWS.getMyIp()
        .then((response) => {
          console.log("My IP:", response);
          this.myIp = response.ip;
        })
        .catch((error) => {
          console.error("Error fetching IP:", error);
        });
    },

    async updateVideos() {
      this.isUpdating = true;
      this.updateSuccess = false;
      try {
        await AdminWS.updateVideos();
        this.updateSuccess = true;
      } catch (error) {
        console.error("Error updating videos:", error);
      } finally {
        this.isUpdating = false;
        setTimeout(() => (this.updateSuccess = false), 5000);
      }
    },
  },
};
</script>

<style scoped>
/* Optional styles */
</style>
